// extracted by css-extract-rspack-plugin
export default {"Box":"selected-repository-pill-module__Box__E8l2O","Text":"selected-repository-pill-module__Text__msUsB","Text_1":"selected-repository-pill-module__Text_1__QjGY_"};